import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { ITrainingActionResource } from "../../training-actions";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ITrainingPhaseResource } from "../types";

export interface IPhaseSkillTarget {
    skill: string;
    levelMin: number;
    levelMax: number;
}

export interface ITrainingPhaseCreateMutationParameters {
    trainingAction: RelationalValue<ITrainingActionResource>;
    name: string;
    modules: string;
    duration: number;
    rank?: number;
    skillTargets?: IPhaseSkillTarget[];
}

export type ITrainingPhaseCreateMutationResult = ITrainingPhaseResource;

export const trainingPhaseCreateMutation: IApiMutationFunction<ITrainingPhaseCreateMutationParameters> = ({
    trainingAction,
    name,
    modules,
    duration,
    rank = 0,
    skillTargets = [],
}) => {
    return {
        method: "POST",
        url: "/training_phases",
        data: {
            uuid: uuid(),
            trainingAction: mapRelationalValueAsIRI(EntityTypes.TRAINING_ACTION, trainingAction),
            name,
            modules,
            duration,
            rank,
            skillTargets,
        },
    };
};

export const useTrainingPhaseCreateMutation = createApiMutationHook<
    ITrainingPhaseCreateMutationParameters,
    ITrainingPhaseCreateMutationResult
>(trainingPhaseCreateMutation);
